import { useState } from 'react';
import { Field } from 'formik';
import { Stack, Text, VStack, Box } from '@chakra-ui/react';
import { FormControl, FormLabel } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import  NameField from 'components/forms/new/formikFormFields/NameField';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';

const AppAuthInitialDomainField = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!(errors.initialDomain && touched.initialDomain)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Initial Domain
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        The initial domain for this App Auth service.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            name="initialDomain"
                            id="initialDomain"
                            placeholder="Initial domain"
                            disabled={true}
                            readOnly={true}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="The initial domain for this service (read-only)"
                        ariaLabel="initial-domain-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AppAuthInitialDomainField;